<template>
    <div :class="skeleton">
        <div class="p-2 loading w-1/2 rounded-full bg-gray-900"></div>
        <div class="p-2 loading w-[90%] rounded-full bg-gray-900"></div>
    </div>
</template>
<script lang="ts" setup>
import { cva } from "class-variance-authority";

interface Props {
    size?: "sm" | "md" | "lg" | "xl";
}
// * CVA button class
const skeleton = computed(() => {
    return cva("flex flex-col space-y-2", {
        variants: {},
        defaultVariants: {},
    })({});
});
const props = defineProps<Props>();
</script>
